import {
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from '@chakra-ui/react';
import { FaEdit } from 'react-icons/fa';
import { MdDelete } from 'react-icons/md';
import { FiTarget } from 'react-icons/fi';
import { TfiMenuAlt } from 'react-icons/tfi';
import { MdAdd } from 'react-icons/md';
import { TiInputChecked } from 'react-icons/ti';
import { IoPersonCircleSharp } from 'react-icons/io5';
import { PiImagesFill, PiWarningCircleBold } from 'react-icons/pi';
import { FcOpenedFolder } from 'react-icons/fc';
import { MdOutlineAccountBalance } from "react-icons/md";

// Custom components
import React, { useEffect, useState } from 'react';
import { Button, Form, Modal } from 'react-bootstrap';
import { SearchBar } from 'components/navbar/searchBar/SearchBar';
import ReactPaginate from 'react-paginate';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { allAppointmentDetail, allBranchDetail, allDoctorDetail, allDoctorSearchDetail, appointementGetById, patientData, patientSearchData, viewLead } from '../../../redux/actions/Files.action';
import { searchDoctor } from '../../../redux/actions/Master.action';
import { addFeedback, deleteFeedback, getAllFeedback, updateFeedback, userFeedback, viewFeedback, viewFeedbackById } from '../../../redux/actions/Feedback.action';
import DiagnosisCard from './DiagnosisCard';
import SuggestionCard from './SuggestionCard';
import Treatments from './Treatments';
import Paramaters from './Paramaters';
import FutureSuggestion from './FutureSuggestion';
import DoctorRemark from './DoctorRemark';
import MedicinesCard from './MedicinesCard';
import { Formik, Field, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import CallLogPatient from './CallLogPatient';
import NextAppointment from './NextAppointment';
import { dateAppointment } from '../../../redux/actions/Doctor.action';

const Clinical = () => {

  const { id } = useParams()
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const doctorData = useSelector((state) => state.files)
  const feedbackData = useSelector((state) => state.feedback)
  const patientIds = doctorData?.getAppointmentById?.data?.appointmentData?.patientId

  const [selectedPatientId, setSelectedPatientId] = useState(patientIds);
  const [isDropdownVisible, setDropdownVisible] = useState(false);
  const [selectedPatient, setSelectedPatient] = useState();

  const [mainPage, setMainPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(3);
  const [feedbackId, setFeedbackId] = useState();

  const [addModal, setAddModal] = useState(false);
  const [updateModal, setUpdateModal] = useState(false);
  const [deleteModal, setDeleteModal] = useState(false);
  const [viewModal, setViewModal] = useState(false);

  const [searchQuery, setSearchQuery] = useState('');
  const [searchDefault, setSearchDefault] = useState({
    search: '',
  });
  const limits = {
    page: mainPage,
    limit: rowsPerPage,
  };

  const initialValues = {
    feedback: ''
  }
  const [formData, setFormData] = useState({ feedback: '' })

  const validationSchema = Yup.object().shape({
    feedback: Yup.string().required('feedback is required')
  });

  const addToggle = () => { setAddModal(!addModal) }
  const updateToggle = () => { setUpdateModal(!updateModal) }
  const deleteToggle = () => { setDeleteModal(!deleteModal) }
  const viewToggle = () => { setViewModal(!viewModal) }

  const type = localStorage.getItem('type')
  const feedbackDatas = feedbackData?.viewFeedback?.data?.FeedbackData

  const toggleDropdown = () => {
    setDropdownVisible(!isDropdownVisible);
  };

  const handlePatientSelect = (patient) => {
    setSelectedPatientId(patient._id);
    setSelectedPatient(patient);
    setDropdownVisible(false);
    dispatch(viewFeedbackById(patientIds, limits))
    navigate(`/doctor/clinical/${patient._id}`);
  };

  useEffect(() => {
    if (patientIds) {
      setSelectedPatientId(patientIds);
    }
  }, [patientIds]);

  const filteredFeedback = feedbackData?.viewFeedbackById?.data?.feedbackData?.filter(
    (res) => res.patientId === selectedPatientId
  );

  const searchData = (e) => {
    const newSearchQuery = e.target.value;
    setSearchQuery(newSearchQuery);
    const newSearchParams = {
      ...searchDefault,
      search: newSearchQuery || ''
    };
    setSearchDefault(newSearchParams);
    dispatch(patientSearchData(newSearchQuery))
  };

  const ChangeMainPage = (selected) => {
    setMainPage(parseInt(selected.selected) + 1);
  };

  const handleRowsPerPageChange = (e) => {
    const newRowsPerPage = parseInt(e.target.value, 10);

    setRowsPerPage(newRowsPerPage);
    setMainPage(1);
  };

  const postPerPage = rowsPerPage;
  const PageCount = Math.ceil(
    feedbackData?.viewFeedbackById?.data?.totalFeedbacks / postPerPage,
  );

  useEffect(() => {
    dispatch(allDoctorDetail())
    dispatch(allBranchDetail())
    dispatch(patientData())
    dispatch(getAllFeedback(selectedPatientId, limits))
    if (id) {
      dispatch(appointementGetById(id));
    }

    if (selectedPatientId) {
      dispatch(viewFeedbackById(selectedPatientId, limits))
    }
  }, [mainPage, rowsPerPage, selectedPatientId, patientIds, id])

  const handleAdd = (values, { resetForm }) => {
    const payload = {
      patientId: selectedPatientId,
      feedback: values.feedback
    }

    dispatch(addFeedback(payload, patientIds, selectedPatientId, limits)).then(() => {
      addToggle();
      resetForm();
    });
  };

  const handleUpdate = (values) => {
    const payload = {
      patientId: selectedPatientId,
      feedback: values.feedback
    }
    dispatch(updateFeedback(payload, feedbackId, selectedPatientId, limits)).then(() => {
      updateToggle()
    })
  }

  const handleDelete = () => {
    dispatch(deleteFeedback(feedbackId, selectedPatientId, limits)).then(() => {
      deleteToggle();
      setMainPage(1);
    })
  }

  const handleView = (id) => {
    dispatch(viewFeedback(id))
  }

  const handleImages = () => {
    navigate(`/master/patientImg/${id}`)
  }

  const handleAccount = () => {
    navigate(`/master/accountInfo/${id}`)
    localStorage.setItem('id', id)
  }

  return (
    <>
      <div className="mt-[100px] d-flex justify-between">
        <div className="flex item-center me-3">
          <div className='relative col-7'>
            <div onClick={toggleDropdown} className="flex gap-2 !text-gray-600 rounded-3 py-2 px-4 border-1 items-center">
              <h6 className="mb-0">
                {selectedPatient?.firstName || doctorData?.getAppointmentById?.data?.appointmentData?.firstName || 'Select Patient'} {" "}
                {selectedPatient?.lastName || doctorData?.getAppointmentById?.data?.appointmentData?.lastName}
              </h6>
              <h6 className="border-l-2 mb-0 px-2 !border-[gray]">
                {selectedPatient?.phoneNumber || doctorData?.getAppointmentById?.data?.appointmentData?.phoneNumber}
              </h6>
            </div>
            {isDropdownVisible && (
              <div className="mt-2 p-2 border rounded bg-white shadow w-full absolute top-full h-[200px] overflow-auto left-0">

                <input type='text' value={searchQuery} onChange={searchData} placeholder='Search patient' className='w-full border p-2 mb-2 rounded outline-none' />

                {doctorData?.allPatient?.data?.PatientData?.length > 0 ? (
                  doctorData?.allPatient?.data?.PatientData?.map((res) => (
                    <p key={res._id} className='mb-2 cursor-pointer' onClick={() => handlePatientSelect(res)}>
                      {res.firstName} {res.lastName} | ( {res.phoneNumber} )
                    </p>
                  ))
                ) : (
                  <p>No any Data</p>
                )}
              </div>
            )}
          </div>
          <div className="flex col-5 gap-2 px-3 !border-[gray]">
            <Form.Select
              placeholder="Select Branch"
              className="shadow-none focus:!border-theme-dark"
              disabled
            >
              <option selected value={selectedPatient ? selectedPatient.branch : doctorData?.getAppointmentById?.data?.appointmentData?.branch}>{selectedPatient ? selectedPatient.branch : doctorData?.getAppointmentById?.data?.appointmentData?.branch}</option>
            </Form.Select>
          </div>
          <div className="flex gap-2 col-5">
            <Form.Group controlId="campaignDetail">
              <div className="relative">
                <input
                  name="doctorName"
                  placeholder={'Select Doctor'}
                  readOnly
                  value={selectedPatient ? selectedPatient.doctorName : doctorData?.getAppointmentById?.data?.appointmentData?.doctor}
                  className="border w-full outline-none border-theme-dark rounded py-[6px] px-[12px]"
                  disabled
                />
              </div>
            </Form.Group>
          </div>
        </div>
        <div className="flex gap-3 items-center me-5">
          {/* <IoPersonCircleSharp className="text-[#B78234] cursor-pointer fs-3" title='Profile' /> */}
          <PiImagesFill onClick={handleImages} className="text-info cursor-pointer fs-3" title='Images' />
          <MdOutlineAccountBalance onClick={handleAccount} className="cursor-pointer fs-3 text-warning" title='Account' />
        </div>
      </div>

      {
        type !== 'Therapist' && (
          <div className="row mt-5 gy-4">
            <div className='col-lg-6'>
              <div className="!bg-[#fff] shadow p-4 rounded-4 h-full">
                <div className="d-flex justify-between">
                  <div className="flex gap-3 items-center">
                    <TfiMenuAlt className="fs-6" />
                    <h6 className="mb-0">Feedback</h6>
                  </div>

                  <div onClick={addToggle} className="w-[30px] flex justify-center items-center h-[30px] rounded-circle !border-red-700 border-1 cursor-pointer">
                    <button disabled={type === 'Receptionist'} className={`${type === 'Receptionist' ? 'cursor-not-allowed' : 'cursor-pointer'}`}><MdAdd className="fs-4 text-danger fw-bold" /></button>
                  </div>
                </div>
                <div className="mt-3">
                  <TableContainer>
                    <Table variant="simple" className="table-bordered">
                      <Thead className="!bg-theme-dark ">
                        <Tr>
                          <Th className="!text-white">Date</Th>
                          <Th className="!text-white">Complains</Th>
                          <Th className="!text-white">User</Th>
                          <Th className="!text-white">Action</Th>
                        </Tr>
                      </Thead>
                      <Tbody>
                        {
                          feedbackData?.getAllFeedback?.data?.FeedbackData && feedbackData?.getAllFeedback?.data?.FeedbackData?.length > 0 ? (
                            <>
                              {
                                feedbackData?.getAllFeedback?.data?.FeedbackData?.map((res) => {
                                  return (
                                    <Tr key={res._id}>
                                      <Td>{new Date(res.createdAt).toLocaleDateString()}</Td>
                                      <Td style={{ whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', maxWidth: '150px' }}>
                                        <span>{res.feedback}</span>
                                      </Td>
                                      <Td>{res?.user}</Td>
                                      <Td>
                                        <div className='flex gap-3 items-center'>
                                          <button disabled={type === 'Receptionist'} className={`${type === 'Receptionist' ? 'cursor-not-allowed' : 'cursor-pointer'}`}><FiTarget className='text-primary' title='view' onClick={() => { viewToggle(); setFeedbackId(res?._id); handleView(res?._id); }} /></button>
                                          <button disabled={type === 'Receptionist'} className={`${type === 'Receptionist' ? 'cursor-not-allowed' : 'cursor-pointer'}`}><FaEdit className='text-success' title='update' onClick={() => { updateToggle(); setFormData(res); setFeedbackId(res?._id); }} /></button>
                                          <button disabled={type === 'Receptionist'} className={`${type === 'Receptionist' ? 'cursor-not-allowed' : 'cursor-pointer'}`}><MdDelete className="text-danger" title="delete" onClick={() => { deleteToggle(); setFeedbackId(res?._id); }} /></button>
                                        </div>
                                      </Td>
                                    </Tr>
                                  )
                                })
                              }
                            </>
                          ) : (
                            <Tr>
                              <Td colSpan={4} textAlign={'center'}>No any feedback</Td>
                            </Tr>
                          )
                        }
                      </Tbody>
                    </Table>
                  </TableContainer>
                </div>
                <div className="flex justify-between items-center mt-2 text-sm">
                  <div>
                    Rows per page:
                    <select
                      value={rowsPerPage}
                      onChange={handleRowsPerPageChange}
                      className="ms-2 border rounded-md focus:outline-none"
                    >
                      <option value="">Select</option>
                      <option value={5}>5</option>
                      <option value={10}>10</option>
                      <option value={30}>30</option>
                      <option value={50}>50</option>
                    </select>
                  </div>

                  <ReactPaginate
                    breakLabel="..."
                    nextLabel=" >"
                    onPageChange={ChangeMainPage}
                    pageRangeDisplayed={3}
                    pageCount={PageCount}
                    forcePage={mainPage - 1}
                    previousLabel="< "
                    renderOnZeroPageCount={null}
                    className="pagination "
                  />
                </div>
              </div>
            </div>

            <NextAppointment patientIds={selectedPatientId} />

            <DiagnosisCard patientIds={selectedPatientId} />

            <SuggestionCard patientIds={selectedPatientId} />
          </div>
        )
      }

      <Treatments patientIds={selectedPatientId} />

      {
        type !== 'Therapist' && (
          <>
            <MedicinesCard patientIds={selectedPatientId} />

            <div className="row mb-3 mt-3">
              <Paramaters patientIds={selectedPatientId} />

              <FutureSuggestion patientIds={selectedPatientId} />

              <DoctorRemark patientIds={selectedPatientId} />
            </div>

            <div className="row">
              <CallLogPatient patientIds={selectedPatientId} />
            </div>
          </>
        )
      }

      {/* View feedback */}
      <Modal show={viewModal} onHide={viewToggle}>
        <Modal.Header closeButton>
          <Modal.Title>View Feedback</Modal.Title>
        </Modal.Header>
        <Modal.Body className=''>
          <div className='row gy-2'>
            <div className='col-4'>Complains</div>
            <div className='col-1'>:</div>
            <div className='col-7'>{feedbackDatas?.feedback}</div>

            <div className='col-4'>Date</div>
            <div className='col-1'>:</div>
            <div className='col-7'>{new Date(feedbackDatas?.createdAt).toLocaleDateString()}</div>

            {/* <div className='col-4'>User</div>
            <div className='col-1'>:</div>
            <div className='col-7'>{feedbackDatas?.feedbackeAddedBy}</div> */}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={viewToggle}
            className="px-4 bg-transparent border-[1px] text-black border-green-color"
          >
            Cancel
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Add Toggle */}
      <Modal show={addModal} onHide={addToggle}>
        <Modal.Header closeButton>
          <Modal.Title>Add Feedback</Modal.Title>
        </Modal.Header>
        <Formik
          initialValues={initialValues}
          validationSchema={validationSchema}
          onSubmit={handleAdd}
        >
          {({ handleSubmit, setFieldValue, values }) => (
            <Form onSubmit={handleSubmit}>
              <Modal.Body>
                <div className="row">
                  <div className="col-12">
                    <Form.Group className="mb-3">
                      <Form.Label>Feedback</Form.Label>
                      <Form.Control
                        type="text"
                        name="feedback"
                        as='textarea'
                        rows={3}
                        onChange={(e) =>
                          setFieldValue('feedback', e.target.value)}
                        value={values.feedback}
                        placeholder="Enter feedback"
                        className="shadow-none focus:!border-theme-dark"
                      />
                      <ErrorMessage
                        name="feedback"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={addToggle}
                  className="px-4 bg-transparent border-[1px] text-black border-green-color"
                >
                  Close
                </Button>
                <Button
                  type="submit"
                  className="!bg-theme-dark border-0 px-4"
                >
                  Add
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>

      {/* Update Toggle */}
      <Modal show={updateModal} onHide={updateToggle}>
        <Modal.Header closeButton>
          <Modal.Title>Add Diagnosis</Modal.Title>
        </Modal.Header>
        <Formik
          initialValues={formData}
          validationSchema={validationSchema}
          onSubmit={handleUpdate}
        >
          {({ handleSubmit, setFieldValue, values }) => (
            <Form onSubmit={handleSubmit}>
              <Modal.Body>
                <div className="row">
                  <div className="col-12">
                    <Form.Group className="mb-3">
                      <Form.Label>Feedback</Form.Label>
                      <Form.Control
                        type="text"
                        name="feedback"
                        as='textarea'
                        rows={3}
                        onChange={(e) =>
                          setFieldValue('feedback', e.target.value)}
                        value={values.feedback}
                        placeholder="Enter feedback"
                        className="shadow-none focus:!border-theme-dark"
                      />
                      <ErrorMessage
                        name="feedback"
                        component="div"
                        className="text-danger"
                      />
                    </Form.Group>
                  </div>
                </div>
              </Modal.Body>
              <Modal.Footer>
                <Button
                  variant="secondary"
                  onClick={updateToggle}
                  className="px-4 bg-transparent border-[1px] text-black border-green-color"
                >
                  Close
                </Button>
                <Button
                  type="submit"
                  className="!bg-theme-dark border-0 px-4"
                >
                  Update
                </Button>
              </Modal.Footer>
            </Form>
          )}
        </Formik>
      </Modal>

      {/* delete feedback */}
      <Modal show={deleteModal} onHide={deleteToggle}>
        <Modal.Body className='p-5'>
          <div>
            <PiWarningCircleBold className='text-7xl w-100 text-danger' />
          </div>
          <div className='text-center mt-4'>
            <h3>Are You Sure ?</h3>
            <p className='text-md'>Do you really want to delete these records?</p>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={deleteToggle}
            className="px-4 bg-transparent border-[1px] text-black border-green-color"
          >
            No
          </Button>
          <Button
            type="submit"
            className="bg-danger border-0 px-4"
            onClick={handleDelete}
          >
            Yes
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default Clinical;
